import { mobile } from "../../../mediaQueries";
import bg from "../../../Dettagli/assets/images/bg.png";

const styles = (theme) => ({
  root: {
    padding: "50px 5rem",
    display: "flex",
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    background: `url(${bg})`,
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      padding: "40px 10px",
    },
  },
  h1: {
    color: "#575452",
    fontSize: "3rem",
    margin: "0",
    fontFamily: "Playfair Display",
    lineHeight: "67.2px",
    fontWeight: "500",
    marginBottom: "50px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      fontSize: "2rem",
      marginBottom: "0",
    },
  },
  p: {
    color: "#575452",
    letterSpacing: "0.02em",
    fontSize: "24px",
    lineHeight: "35px",
    margin: "0",
    fontFamily: "Aktiv Grotesk",
    fontWeight: "400",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      fontSize: "1rem",
      marginTop: "3rem",
    },
  },
  span: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "1.1rem",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      flexDirection: "column",
      marginTop: "0",
    },
  },
  btn: {
    cursor: "none !important",

    borderRadius: "0",
    border: "2px solid #0045EA",
    padding: "10px 20px",
    color: "#0045EA",
    fontFamily: "Aktiv Grotesk",
    fontWeight: "500",
    lineHeight: "24px",
    minWidth: "215px",
    margin: "10px",
    transition: "all 0.3s",
    textTransform: "none",
    "&:hover": {
      color: "#09349C",
      border: "2px solid #09349C",
    },
  },
  iframe: {
    flexBasis: "60%",
    width: "100%",
    maxWidth: "896px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    opacity: 0,
    transition: "opacity 2.5s cubic-bezier(.4,.28,0,1.03)",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      flexBasis: "40%",
    },
  },
  ctaWrap: {
    display: "flex",
    marginTop: "50px",
    opacity: 0,
    transition: "opacity 3s cubic-bezier(.4,.28,0,1.03)",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: "fit-content",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      marginTop: 0,
      width: "100%",
    },
  },
});

export default styles;
